<template>
    <transition name="fade">
        <div class="spinner-container" v-if="visible">
            <div class="spinner-icon">
                <h3 v-if="message">{{ message }}</h3>
                <pulse-loader :loading="true"></pulse-loader>
            </div>
        </div>
    </transition>
</template>

<style lang="scss" scoped>
    @import "../../sass/common/variables";
    @import "../../sass/common/mixins";

    .spinner-container {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(255, 255, 255, 0.75);
        z-index: 99999;
        text-align: center;
    }

    .spinner-icon {
        max-width: 80%;
        height: 85px;
        margin: 0 auto;

        h3 {
            margin: 0;
        }

        .v-spinner {
            padding: $default-padding 0;
        }

        @include center();
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0
    }
</style>

<script>
    export default {

        data() {
            return {
                visible: false,
                message: null
            }
        },

        created: function() {
            this.$events.$on('spinner.show', this.show);
            this.$events.$on('spinner.hide', this.hide)
        },

        methods: {
            show(data) {
                if(data.message) {
                    this.message = data.message
                }

                this.visible = true
            },
            hide() {
                this.visible = false
            }
        }

    }
</script>
